// https://dev.to/doctolib/using-promises-as-a-queue-co5
export default class PromiseQueue {
  private queue: Promise<any>;
  private active = true;

  constructor() {
    this.queue = Promise.resolve(true);
  }

  add<T>(operation: ((value: T) => T | PromiseLike<T>)) : Promise<T> {
    return new Promise((resolve, reject) => {
      if (this.active) {
        this.queue = this.queue
          .then(operation)
          .then(resolve)
          .catch(reject)
      } else {
        Promise.resolve<any>(true)
          .then(operation)
          .then(resolve)
          .catch(reject)
      }
    })
  }

  stop() {
    this.active = false;
  }

  start() {
    this.active = true;
  }

  clear() {
    this.queue = Promise.resolve(true);
  }
}